<template>
  <div class="editCustomer">
    <headerNotice routerName="编辑资料"></headerNotice>
    <div class="content"
         v-loading="loading">
      <el-form :inline="true"
               ref="editCustomer"
               :model="editCustomer"
               label-width="120px">
        <div class="editTitle">
          <h2>公司信息</h2>
        </div>
        <el-row :gutter="5">
          <el-col :span="6">
            <el-form-item label="客户名称">
              <el-input v-model="editCustomer.customerName"></el-input>
            </el-form-item>
          </el-col>
          <!-- 无客户编号字段 -->
          <!-- <el-col :span="6">
                        <el-form-item label="客户编号">
                            <el-input v-model="editCustomer.userId"></el-input>
                        </el-form-item>
                    </el-col>-->
          <el-col :span="6">
            <el-form-item label="所属业务员">
              <el-input v-model="editCustomer.salesmanName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所在地区">
              <el-input v-model="editCustomer.areaName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="详细地址">
              <el-input v-model="editCustomer.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮编">
              <el-input maxlength="6"
                        v-model="editCustomer.postcode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="传真">
              <el-input v-model="editCustomer.fax"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="电话">
              <el-input v-model="editCustomer.tel"></el-input>
            </el-form-item>
          </el-col>
          <!-- 无备用信息字段 -->
          <!-- <el-col :span="6">
                        <el-form-item label="备用信息">
                            <el-input v-model="editCustomer.remarkMsg"></el-input>
                        </el-form-item>
                    </el-col>-->
        </el-row>

        <div class="editTitle">
          <h2>联系人信息</h2>
        </div>
        <el-row :gutter="5">
          <el-col :span="6">
            <el-form-item label="联系人">
              <el-input v-model="editCustomer.linkman"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="微信">
              <el-input v-model="editCustomer.weiXin"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机">
              <el-input v-model="editCustomer.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱">
              <el-input v-model="editCustomer.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="qq">
              <el-input v-model="editCustomer.qq"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="editTitle">
          <h2>账号信息</h2>
        </div>
        <el-row>
          <el-col>
            <el-form-item label="账号">
              <el-input v-model="editCustomer.userName"
                        readonly></el-input>
            </el-form-item>
          </el-col>
          <!-- 暂无重置密码接口 -->
          <el-col>
            <el-form-item label="密码">
              <el-input type="password"
                        v-model="editCustomer.password"
                        readonly
                        placeholder="******">
                <el-button @click='resetPassword'
                           type="primary"
                           slot="append">重置密码</el-button>
              </el-input>
            </el-form-item>
            <el-form-item v-if='tipsFlag'
                          style="margin-left: 30px;">
              <span>密码已重置为：yth123456</span>
            </el-form-item>
          </el-col>
          <!-- <el-col>
                        <span style="margin-left: 10px;">密码已重置为：yth123456</span>
                    </el-col> -->
          <el-col>
            <el-form-item label="状态"
                          prop="status">
              <el-radio-group v-model="editCustomer.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="editTitle">
          <h2>财务信息</h2>
        </div>
        <el-row :gutter="5">
          <el-col :span="6">
            <el-form-item label="开户名称">
              <el-input v-model="editCustomer.accountName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开户银行">
              <el-input v-model="editCustomer.depositBank"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="银行账号">
              <el-input v-model="editCustomer.accountNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="纳税人识别号">
              <el-input v-model="editCustomer.taxNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发票抬头">
              <el-input v-model="editCustomer.invoiceName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btnGroup">
          <el-button type="primary"
                     @click="onSubmit">提交</el-button>
          <el-button @click="onCancle">返回</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      loading: true,
      editCustomer: {},
      tipsFlag: 0
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    console.log(this.$route.query);
    //从路由提取userID
    this.onCustomerDetail(this.$route.query);
  },
  methods: {
    resetPassword() {

      let self = this;
      let search = `?userId=${self.editCustomer.userID}`;
      console.log(self.editCustomer.userID);
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminUser/ResetUserPassword" +
          search,
        success(res) {
         
          self.$message.success("密码重置成功");
          self.tipsFlag = 1;
        },
        fail(res) {
          console.log(res);
        }
      });
    },
    //提交修改
    onSubmit() {
      let self = this;
      console.log(this.editCustomer);
      this.loading = true;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCustomer/ModifyInfo",
        data: this.editCustomer,
        success(res) {
          //message组件
          self.$message({
            showClose: true,
            message: res.data,
            type: "success"
          });
          self.$router.push({
            path: "/customer"
          });
          self.loading = false;
        },
        fail(res) {
          self.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          self.loading = false;
        }
      });
    },
    onCancle() {
      this.$router.push({
        path: "/customer"
      });
    },
    //查看客户详情
    onCustomerDetail(row) {
      let self = this;
      this.customerDetailsVisible = true;
      this.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminCustomer/GetInfo",
        params: { userId: row.userId },
        success(res) {
          console.log(res);
          self.editCustomer = res;
          console.log(self.editCustomer);
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.editCustomer {
  .content {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    .editTitle {
      // display: flex;
      width: 100%;
      height: 40px;
      line-height: 40px;
      margin-bottom: 10px;
      // align-items: center;
      border-bottom: 1px solid #c5c5c5;
      h2 {
        padding-left: 20px;
      }
    }
    .btnGroup {
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
</style>
